import ApiService from './api.service.js';

const serviceUrl = '/security';

export default {
  async changePassword(currentPassword, newPassword) {
    return ApiService.put(`${serviceUrl}/security-users/password/`, {
      currentPassword,
      newPassword
    });
  }
};
